import { NgModule } from 'ng-metadata/core';
import './button.scss';

/**
 * @ngdoc module
 * @name mw.components.button
 * @description
 *
 * Button
 */
@NgModule({})
export class ButtonModule {}



// WEBPACK FOOTER //
// ./src/lib/components/button/button.module.ts